import { render, staticRenderFns } from "./PanelRow.vue?vue&type=template&id=54e7a01c&"
import script from "./PanelRow.vue?vue&type=script&lang=js&"
export * from "./PanelRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports